import React, { Component } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

// import AccountRecovery from './pages/AccountRecovery'
import CounselorTraining from './pages/CounselorTraining'
import EditPatient from './pages/EditPatient'
import Goal from './pages/Goal'
import Learn from './pages/Learn'
import Login from './pages/Login'
import Logout from './pages/Logout'
import PatientLogin from './pages/PatientLogin'
import PatientSession from './pages/PatientSession'
import PhoneSession from './pages/PhoneSession'
import Plan from './pages/Plan'
import PreCourse from './pages/PreCourse'
import Print from './pages/Print'
import Screening from './pages/Screening'
import CombatScreening from './pages/CombatScreening'
import SessionIntro from './pages/SessionIntro'
import Profile from './pages/Profile'
import Resources from './pages/Resources'
import Use from './pages/Use'
import SEEVideoExamples from './pages/SEEVideoExamples'
import Landing from "./pages/Landing"
import Patients from './pages/Patients'
import Demo from './pages/Demo'
import BackupScreeningPdfs from './pages/BackupScreeningPdfs'
import SIGHTVideoExamples from "./pages/SIGHTVideoExamples";
import TrainerGuides from "./pages/TrainerGuides";
import {ExternalLogin} from "./pages/ExternalLogin";
import SignUp from "./pages/SignUp";
import {Publications} from "./pages/Publications";
import {AdherenceStats} from "./pages/AdherenceStats";
import AdherenceDashboard from "./pages/AdherenceDashboard";
import SightLanding from "./pages/SightLanding";

export default class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route
            path="/"
            component={Landing}
            exact
          />
          <Route
            path="/mi-sight"
            component={SightLanding}
            exact
          />
          <Route
            path="/login"
            component={Login}
            exact
          />
          <Route
            path="/external-login"
            component={ExternalLogin}
            exact
          />
          <Route
            path="/sign-up"
            component={SignUp}
            exact
          />
          <Route
            path="/demo/:which(learn|use|goal|plan|print|screening)"
            component={Demo}
            exact
          />
          <Route
            path="/patients"
            component={Patients}
            exact
          />
          <Route
            path="/adherence-dashboard"
            component={AdherenceDashboard}
            exact
          />
          <Route
            path="/demo"
            component={Demo}
            exact
          />
          <Route
            path="/logout"
            component={Logout}
            exact
          />
          <Route
            path="/edit-patient/:patientID"
            component={EditPatient}
            exact
          />
          <Route
            path="/learn/:session(first|second|third)/:patientID"
            component={Learn}
            exact
          />
          <Route
            path="/use/:session(first|second|third)/:patientID"
            component={Use}
            exact
          />
          <Route
            path="/goal/:session(first|second|third)/:patientID"
            component={Goal}
            exact
          />
          <Route
            path="/plan/:session(first|second|third)/:patientID"
            component={Plan}
            exact
          />
          <Route
            path="/print/:patientID/:whatToPrint(plan|login|screening)"
            component={Print}
            exact
          />
          <Route
            path="/session-intro/:session(third)/:patientID"
            component={SessionIntro}
            exact
          />
          <Route
            path="/patient-login"
            component={PatientLogin}
            exact
          />
          <Route
            path="/patient-session/:page(learn|use|goal|print|adherence)"
            component={PatientSession}
            exact
          />
          <Route
            path="/profile"
            component={Profile}
            exact
          />
          <Route
            path="/phone-session/:patientID"
            component={PhoneSession}
            exact
          />
          <Route
            path="/resources/pre-course"
            component={PreCourse}
            exact
          />
          <Route
            path="/resources/see-video-examples"
            component={SEEVideoExamples}
            exact
          />
          <Route
            path="/resources/sight-video-examples"
            component={SIGHTVideoExamples}
            exact
          />
          <Route
            path="/resources/counselor-training"
            component={CounselorTraining}
            exact
          />
          <Route
            path="/resources/backup-screening-pdfs"
            component={BackupScreeningPdfs}
            exact
          />
          <Route
              path="/resources/trainer-guides"
              component={TrainerGuides}
              exact
          />
          <Route
            path="/resources"
            component={Resources}
            exact
          />
          <Route
            path="/screening/:patientID"
            component={Screening}
            exact
          />
          <Route
            path="/combat-screening/:patientID"
            component={CombatScreening}
            exact
          />
          <Route
            path="/publications"
            component={Publications}
            exact
          />
          <Route
            path="/adherence-stats/:patientID"
            component={AdherenceStats}
            exact
          />
          <Route render={() => <h1>404 Not Found</h1>} />
        </Switch>
      </BrowserRouter>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js